<div class="h-100" style="  display: grid;
grid-template-rows: auto 1fr auto;">
    <app-navbar></app-navbar>

    <div>
        <router-outlet></router-outlet>
    </div>

    <app-footer></app-footer>
</div>